import { useState, useEffect } from "react";
import { FILTERS_STORAGE_KEY, SHOW_FILTERS_STORAGE_KEY, DEFAULT_FILTERS, FILTERS_VERSION } from "../constants";

export const useFilters = () => {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);
  const [showFilters, setShowFilters] = useState(false);

  // Load saved filters from localStorage on component mount
  useEffect(() => {
    try {
      const savedData = localStorage.getItem(FILTERS_STORAGE_KEY);
      if (savedData) {
        const { version, filters: savedFilters } = JSON.parse(savedData);

        // Only use saved filters if version matches, otherwise use defaults
        if (version === FILTERS_VERSION) {
          setFilters(savedFilters);
        } else {
          // Version mismatch - use defaults and save new version
          localStorage.setItem(
            FILTERS_STORAGE_KEY,
            JSON.stringify({
              version: FILTERS_VERSION,
              filters: DEFAULT_FILTERS,
            })
          );
        }
      }
    } catch (err) {
      console.error("Error loading saved filters:", err);
      // Reset to defaults on any error
      setFilters(DEFAULT_FILTERS);
    }
  }, []);

  // Save filters to localStorage whenever they change
  useEffect(() => {
    try {
      localStorage.setItem(
        FILTERS_STORAGE_KEY,
        JSON.stringify({
          version: FILTERS_VERSION,
          filters: filters,
        })
      );
    } catch (err) {
      console.error("Error saving filters:", err);
    }
  }, [filters]);

  // Load show filters state from localStorage on component mount
  useEffect(() => {
    try {
      const savedShowFilters = localStorage.getItem(SHOW_FILTERS_STORAGE_KEY);
      if (savedShowFilters !== null) {
        setShowFilters(JSON.parse(savedShowFilters));
      }
    } catch (err) {
      console.error("Error loading saved filters visibility state:", err);
    }
  }, []);

  // Toggle filter states
  const toggleFilter = (filterName) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: !prev[filterName],
    }));
  };

  // Save show filters state to localStorage
  const handleToggleFilters = () => {
    const newState = !showFilters;
    setShowFilters(newState);
    try {
      localStorage.setItem(SHOW_FILTERS_STORAGE_KEY, JSON.stringify(newState));
    } catch (err) {
      console.error("Error saving filters visibility state:", err);
    }
  };

  return {
    filters,
    showFilters,
    toggleFilter,
    handleToggleFilters,
  };
};
